import { render, staticRenderFns } from "./email-unverified-page.vue?vue&type=template&id=94e5c076&scoped=true&"
import script from "./email-unverified-page.vue?vue&type=script&lang=js&"
export * from "./email-unverified-page.vue?vue&type=script&lang=js&"
import style0 from "./email-unverified-page.vue?vue&type=style&index=0&id=94e5c076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e5c076",
  null
  
)

export default component.exports
import {QBtn,QSpinnerIos} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QSpinnerIos})
